export default "__VITE_ASSET__P4DPfwIRieI8P6q8r4JZRw__ 480w, __VITE_ASSET__cn7IAAGY294pWGc7MpElVg__ 768w, __VITE_ASSET__DUq8YoikZLXEejpNZ1KQvg__ 1200w";